//MUI
import { Button, Grid, Stack, TextField, Typography } from "@mui/material";
import { DataGrid, GridToolbarContainer, GridToolbarQuickFilter, } from "@mui/x-data-grid";
import DownloadIcon from '@mui/icons-material/Download';

import UPagination from "./UPagination";

import { fnExcel } from "../../services/commonService";
import { fni18n } from "../../services/commonService";
import { useState } from "react";

const GridToolbarCust = (props) => {
  const toolbarAdd = props.props.toolbarAdd;
  const columns = props.props.columns;
  const rows = props.props.data;
  const element = (<>
    {
      toolbarAdd && toolbarAdd.map((m,i)=>(
      <>
      <Button 
            color="primary"
            variant="text"
            size="small"
            sx={{fontWeight: "bold", fontSize: 13, mt: 1, mr: 2}}
            startIcon={m.icon}
            onClick={()=>{m.onclick(m.text)}}
          >
            {fni18n(m.text)}
          </Button>
      </>))
    }
  </>);

  return(
    <>
    <GridToolbarContainer> 
    <Grid container item xs>
      &nbsp;&nbsp;Result ( Total : {`${rows.length}`} )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      {/* default buttons */}
      {/*<GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport />*/}
    {/* <GridToolbarQuickFilter /> */}
    </Grid>
    
    <Grid>
      {element}
      <Button
          color="success"
          variant="text"
          size="small"
          sx={{fontWeight: "bold", fontSize: 13, mt: 1, mr: 2}}
          startIcon={<DownloadIcon />}
          onClick={(e)=>fnExcel(columns,rows,e)}
        >
          {fni18n('엑셀')}
        </Button>  
    </Grid>
    </GridToolbarContainer>
    </>
  );
}

const UDataGrid = (props) => {
  const columns = props.columns;
  const rows = props.data;
  const checkBoxYn = props.checkYn;                                   //체크박스 유무 (true, false) 
  const columnGroupingModel = props.columnGroupingModel;              //ColumnGrouping
  const toolbarAdd = props.toolbarAdd;                                //toolbar에 추가할 버튼 []  //ex: [{text:'파일업로드',icon:<DownloadIcon />,onclick:onButtonClick},{},..]
  const key = props.key;
  const title = props.title;
  const height = props.height;

  const onPageChange = (pageNum) =>{
    let e = {
      target : {
        name : "pageNum",
        value : pageNum,
      },
    }
    props.onPageChange(e);
  };

  return (
    <div style={{ width: "100%", display: "grid", height: 500 }} key={key}>
        {title && <Typography variant="h6" align="justify" sx={{margin:"0.3em"}}>{title}<br/></Typography>}
        <DataGrid
          sx={{ fontSize: "13px", minHeight: height||"65vh", fontFamily: "Arial" }}
          columns={columns}
          rows={rows}
          disableColumnMenu
          rowHeight={40}
          columnHeaderHeight={40}
          density='compact'
          pageSize={15}
          rowsPerPageOptions={[15]}
          checkboxSelection={checkBoxYn}
          experimentalFeatures={{ newEditingApi: true, columnGrouping: true }}
          columnGroupingModel={columnGroupingModel}
          autoHeight={true}
          onRowClick={(rows) => {
            {props.onSelectedRow && props.onSelectedRow(rows.row)}
          }}
          onSelectionModelChange={(ids) => { //checkbox에서 check된 rows 전달
            const selectedRowsData = ids.map((id) => rows.find((row) => row.id === id));
            {props.onSelectedRows && props.onSelectedRows(selectedRowsData)}
          }}
          hideFooterSelectedRowCount
          components={{
            Footer:()=>(
              <>
                <UPagination onPageChange={onPageChange} />
                <GridToolbarCust props={props}/>
              </>
            ),
            NoRowsOverlay: () => (
              <Stack height="100%" justifyContent="center" alignItems="center">
                {fni18n('조회결과 없음')}
              </Stack>
            ),
          }}
        />
    </div>
  );
};

export default UDataGrid;